import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MessagePopUp from "../../components/Messages/MessagePopUp";
import Flags from "./Flags";
import PostVisitCard from "./PostVisitCards/PostVisitCard";
import { Tabs } from "antd";
import TabPane from "antd/es/tabs/TabPane";

const validPages = {
  "?Flags": "Flags",
  "?PostVisits": "PostVisits",
};

function MainFlags() {
  const [activeKey, setActiveKey] = useState("Flags");
  const [message, setMessage] = useState({
    trigger: false,
    type: "",
    icon: "",
    title: "",
    text: "",
  });
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setActiveKey(validPages[location.search]);
  }, [location]);

  const handleTabChange = (key) => {
    navigate(`/project/flags?${key}`);
  };

  return (
    <div className=" planning-page p-0">
      <MessagePopUp
        trigger={message.trigger}
        type={message.type}
        icon={message.icon}
        messageTitle={message.title}
        messageText={message.text}
      />
      <Tabs
        activeKey={activeKey}
        onChange={handleTabChange}
        type="card"
        className="card-tabs mt-3"
        destroyInactiveTabPane={true}
      >
        <TabPane tab="Flags" key="Flags">
          <div className="insideTab implementationPage">
            <Flags />
          </div>
        </TabPane>
        <TabPane tab="Post-Visit Card Board" key="PostVisits">
          <div className="insideTab implementationPage">
            <PostVisitCard />
          </div>
        </TabPane>
      </Tabs>
    </div>
  );
}

export default MainFlags;
